/* eslint-disable react/prop-types */
import React from 'react';
import i18next from 'i18next';
import styled from 'react-emotion';
import changeCase from 'change-case';

import { Row, Column } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import { Label } from '~/modules/coreUI/components/basic/Labels';
import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';
import InnerIcon from '~/modules/coreUI/components/basic/Icon';
import Separator from '~/modules/coreUI/components/layouts/helpers/Separator';
import injectInBetween from '~/modules/core/utils/jsHelpers/injectElementBetweenChildElements';

const Icon = styled(InnerIcon)`
  color: ${props => props.theme.new.colors.labels.normal.subtle} !important;
  font-size: ${props => props.theme.new.fonts.sizes.xxl}px;
`;

const InlineSpacer = styled(Spacer)`
  display: inline-block;
`;

export const iconDictionary = {
  pickup: 'pickup',
  qpost: 'q-post',
  by_shop: 'by-shop',
};

class ShippingMethods extends React.PureComponent { // eslint-disable-line
  render = () => (
    <Column>
      <Row fullWidth>
        <Label sm important semiBold>
          {i18next.t('ecommerceOrder:Cart.shipping')}
        </Label>
      </Row>
      <Spacer size={1} />
      <Row fullWidth rightJustified>
        {injectInBetween(
          this.props.shippingMethods.map(method => (
            <div key={method.title}>
              <Icon className={`el-icon el-icon-${iconDictionary[method.code]}`} size="lg" title={method.description} />
              <InlineSpacer size={0.5} />
              <Label xs secondary>
                {changeCase.titleCase(method.title)}
              </Label>
            </div>
          )),
          <Separator vertical separatorLength="large" />,
          true,
        )}
      </Row>
    </Column>
  );
}

export default ShippingMethods;
